import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormInputComponent, IFormInputTextChangedArg, IFormInputViewModel } from '../form-input/form-input.component';
import { FormOkCancelComponent, IFormOkCancelViewModel } from '../form-ok-cancel/form-ok-cancel.component';

@Component({
  selector: 'app-form-comment',
  templateUrl: './form-comment.component.html',
  styleUrls: ['./form-comment.component.scss']
})
export class FormCommentComponent implements OnInit {

  @Input() formTitle: string = 'Comment Entry';
  @Input() inputTitle: string = 'Comment';

  @Input() minLength: number = undefined;
  @Input() required: boolean = false;

  @Output() accepted = new EventEmitter<IFormCommentAcceptedEventArg>();
  @Output() cancelled = new EventEmitter<any>();

  isInvalid: boolean = true;

  vm: IFormInputViewModel;
  vmOkCancel: IFormOkCancelViewModel;

  constructor() { }

  /**
   * 
   */
  ngOnInit(): void {
    const data = { comment: '' };

    this.vmOkCancel = FormOkCancelComponent.okCancelVm();

    this.vm = FormInputComponent.viewModel(data, 'comment',
      { type: 'textarea', title: this.inputTitle, isRequired: this.required, minLength: this.minLength }
    );
    this.validate(this.vm);
  }

  /**
   * 
   * @param vm 
   */
  private validate(vm: IFormInputViewModel) {
    this.isInvalid = !this.required ? false 
      : vm.dataGet().toString().length > 0 ? false
      : true;
  }

  /**
   * 
   * @param vm 
   * @param arg 
   */
  textChanged(vm: IFormInputViewModel, arg: IFormInputTextChangedArg) {
    this.validate(vm);
  }

  /**
   * 
   * @param vm 
   */
  ok(vm: IFormInputViewModel) {
    const arg: IFormCommentAcceptedEventArg = {
      okCancelVm: this.vmOkCancel,
      comment: vm.dataGet()
    }
    this.accepted.emit(arg);
  }

  /**
   * 
   * @param vm 
   */
  cancel(vm: IFormInputViewModel) {
    this.cancelled.emit();
  }

}

/**
 * 
 */
export interface IFormCommentAcceptedEventArg {
  okCancelVm: IFormOkCancelViewModel;

  comment?: string;
}
